module.exports = __webpack_public_path__ + "static/media/IconTemplates_-36.71d6f9d1.svg";